var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 25.1875C15.8958 24.1875 18.25 23.6875 20.5 23.6875C22.75 23.6875 25.0833 24.1875 27.5 25.1875C29.9583 26.1458 31.1875 27.4167 31.1875 29V31.6875H9.8125V29C9.8125 27.4167 11.0208 26.1458 13.4375 25.1875ZM24.25 19.4375C23.2083 20.4792 21.9583 21 20.5 21C19.0417 21 17.7917 20.4792 16.75 19.4375C15.7083 18.3958 15.1875 17.1458 15.1875 15.6875C15.1875 14.2292 15.7083 12.9792 16.75 11.9375C17.7917 10.8542 19.0417 10.3125 20.5 10.3125C21.9583 10.3125 23.2083 10.8542 24.25 11.9375C25.2917 12.9792 25.8125 14.2292 25.8125 15.6875C25.8125 17.1458 25.2917 18.3958 24.25 19.4375Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInput);
export default __webpack_public_path__ + "static/media/account_input.78275d943a4d7e665b700a11b95f6366.svg";
export { ForwardRef as ReactComponent };